import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Svg from '../../../common/svgIcon';
import { ReduxFormCheckbox } from '../../../common/checkbox/';
import { getGamblingCompliance } from '../../../common/gamblingCompliance';
import {
    findAnalytics,
    logToAnalyticsBookmakerOpenAccount,
} from '../../../App/analyticsTracking';

export class LoginForm extends Component {

    onCreateAccount = () => {
        const { feed } = this.props;
        const analytics = findAnalytics();
        if (analytics) {
            logToAnalyticsBookmakerOpenAccount(feed, analytics, true);
        }
    }

    renderErrorMessage = () => (
        <div className="bs-section bs-loginForm__error">
            <span>Invalid username or password. Please try again</span>
        </div>
    )

    renderActionBar = () => (
        <div className={classNames('bs-actionBar', 'bs-section', this.props.actionBarClass)}>
            <a
                onClick={this.onCreateAccount}
                href={this.props.registrationLink}
                target="__blank"
                className={classNames(
                    'bs-btn',
                    'bs-btn_default',
                    'bs-btn_link',
                    'bs-actionBar__button',
                    'bs-actionBar__button_2XL',
                    'bs-actionBar__half',
                )}
            >
                Create an Account
            </a>
            <button
                type="submit"
                className={classNames(
                    'bs-btn',
                    'bs-btn_major',
                    'bs-actionBar__button',
                    'bs-actionBar__half',
                )}
            >
                <span>Sign In</span>
            </button>
        </div>
    )

    render() {
        const { feed } = this.props;
        const gamblingCompliance = getGamblingCompliance(feed);
        return (
            <div>
                <form onSubmit={this.props.handleSubmit} className="bs-loginForm">
                    <div className="bs-loginForm__body">
                        <div className="bs-form__group">
                            <div className="bs-form__field bs-loginForm__leftField bs-col_8">
                                <label
                                    htmlFor="username"
                                    className="bs-form__label"
                                >
                                    Username
                                </label>
                                <Field
                                    name="username"
                                    component="input"
                                    type="text"
                                    placeholder="Username"
                                    className="bs-input bs-form__input bs-loginForm__input"
                                />
                            </div>
                            <div className="bs-form__field bs-loginForm__rightField">
                                <span className="bs-form__label">
                                    Save
                                </span>
                                <Field
                                    name="saveUsername"
                                    component={ReduxFormCheckbox}
                                    onChange={this.props.onSaveUsernameChange}
                                    className="bs-loginForm__checkbox"
                                    iconType="color"
                                    iconSize="XL"
                                    props={{ tabIndex: -1 }}
                                />
                            </div>
                        </div>
                        <div className="bs-form__group">
                            <div
                                className={classNames(
                                    'bs-form__field',
                                    'bs-loginForm__leftField',
                                    'bs-col_8',
                                )}
                            >
                                <label
                                    htmlFor="password"
                                    className="bs-form__label"
                                >
                                    Password
                                </label>
                                <Field
                                    name="password"
                                    component="input"
                                    type="password"
                                    placeholder="Password"
                                    className="bs-input bs-form__input bs-loginForm__input"
                                />
                            </div>
                        </div>
                        { this.props.isIncorrectCredentials ? this.renderErrorMessage() : null }
                        <div className="bs-section">
                            <Link
                                className={classNames(
                                    'bs-link',
                                    'bs-link_major',
                                    'bs-loginForm__forgottenPasswordLink',
                                )}
                                to={`/${feed}/forgotten-password`}
                            >
                                <Svg
                                    iconName="right"
                                    size="Medium"
                                    className="bs-loginForm__forgottenPasswordIcon"
                                />
                                <span className="bs-loginForm__forgottenPasswordText">
                                    Forgotten Password?
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="bs-loginForm__compliance-padding">
                        { this.props.showGamblingCompliance ? gamblingCompliance : null }
                    </div>
                    { this.renderActionBar() }
                </form>
            </div>
        );
    }
}


LoginForm.defaultProps = {
    registrationLink: null,
    actionBarClass: '',
    showGamblingCompliance: false,
    isIncorrectCredentials: null,
}

LoginForm.propTypes = {
    feed: PropTypes.string.isRequired,
    registrationLink: PropTypes.string,
    actionBarClass: PropTypes.string,
    showGamblingCompliance: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    onSaveUsernameChange: PropTypes.func.isRequired,
    isIncorrectCredentials: PropTypes.bool,
}

export default reduxForm({
    form: 'loginForm',
    destroyOnUnmount: false,
})(LoginForm);



// WEBPACK FOOTER //
// /src/js/common/loginPage/components/LoginForm.jsx